//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.PartPreferences.js";
let d=[[[0,"DesignatorLibSource",1,0],[0,"PrefixAppearanceAreas",1,0],[0,"PrefixAppearanceDesignators",1,0],[0,"PrefixAppearanceSchemes",1,0]],[[[],"GetDesignatorLibraryFile",{R_:{designator_file:''}},0,0],[["designator_file"],"SetDesignatorLibraryFile",{},1,0]],[]];
SPLM.Preferences.PartAppearanceMgrPreference = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartAppearanceMgrPreference";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.PartAppearanceMgrPreference.DesignatorSourceType = Object.freeze({
    "ProductStructure" : "ProductStructure", "File" : "File"});

export default SPLM;